import BookIcon from '@material-ui/icons/Book'
import BusinessReceiptShow from './BusinessReceiptShow'
import BusinessReceiptList from './BusinessReceiptList'

export default {
  list: BusinessReceiptList,
  show: BusinessReceiptShow,
  icon: BookIcon,
}
